import type { QuoteFields, ThemeColor } from '@boss/types/corporate-jobs';
import { Image } from '@boss/types/corporate-jobs';

export const getQuoteProps = (
  entry: QuoteFields,
  themeColor?: ThemeColor,
  hasBackground?: boolean,
): {
  quote: string;
  author?: string;
  company?: string;
  image?: Image;
  imagePosition?: 'left' | 'right';
  themeColor?: ThemeColor;
  background?: boolean;
} => {
  return {
    themeColor: themeColor,
    quote: entry.quote,
    company: entry.company,
    author: entry.author,
    image: entry.image,
    imagePosition: entry.imagePosition ?? 'left',
    background: hasBackground,
  };
};

export default getQuoteProps;
